import { defineComponent as _defineComponent } from 'vue';
import { reactive } from "vue";
import { VContainer, VRow, VCol, VCard, VList, VListItem, VIcon } from "vuetify/lib";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosMenuDemo',
    setup(__props) {
        const contextMenu = reactive({
            show: false,
            x: 0,
            y: 0,
        });
        const handleContextMenu = (e) => {
            contextMenu.show = false;
            contextMenu.x = e.clientX;
            contextMenu.y = e.clientY;
            setTimeout(() => {
                contextMenu.show = true;
            }, 50);
        };
        return { __sfc: true, contextMenu, handleContextMenu, VContainer, VRow, VCol, VCard, VList, VListItem, VIcon };
    }
});
